import Layout, { Content } from 'antd/es/layout/layout';
import { useContext } from 'react';
import Header from 'src/components/NewFeatures/Header';
import ModernSidebar from 'src/components/v2/Sidebar/ModernSidebar';
import { AppContext } from 'src/contexts/app.context';
import styles from './MainLayout.module.scss';

interface Props {
  children?: React.ReactNode;
  hasSidebar?: boolean;
}

export default function MainLayout({ children }: Props) {
  const { isSidebarCollapsed } = useContext(AppContext);

  return (
    <main className={styles.mainLayout}>
      <Header />
      <Layout className=''>
        <ModernSidebar />
        {children && (
          <Content className={`${styles.pageContent} ${isSidebarCollapsed ? styles.mainCollapsed : ''}`}>
            <div className={styles.container}>{children}</div>
          </Content>
        )}
      </Layout>
    </main>
  );
}
